import CrudRequest from '@/app/arch/components/crud/CrudRequest';
import httpService from '@/app/arch/services/HttpService';

class MarcaIntegradorRequest extends CrudRequest {
  static baseUrl() {
    return '/produto-servico/marca';
  }

  static list(queryParams = {}, idMarca = null) {
    return httpService.get(`${this.baseUrl()}/integradores`, {
      params: {
        idMarca,
        ...queryParams,
      },
    });
  }

  static remove(id, idMarca = null) {
    return httpService.delete(`${this.baseUrl()}/${idMarca}/integrador/${id}`);
  }

  static save(payload) {
    return httpService.post(`${this.baseUrl()}/integrador`, payload);
  }

  static listintegrador() {
    return httpService.get('/produto-servico/integrador/list-all', {
      params: {
        page: 1,
        size: 1000,
      },
    });
  }
}

export default MarcaIntegradorRequest;
